import React, { ReactNode, useRef, useState } from 'react';
import cx from 'classnames';

import chevron from '~assets/chevron-down.svg';

import styles from './styles.module.scss';

interface Props {
  title: string;
  open?: boolean;
  /** Grow to fill its flex container, panel included. */
  fill?: boolean;
  className?: string;
  children?: ReactNode;
}

let nextId = 0;

/** A Ficha section: a bar that opens and closes the panel below it. */
function Dropdown({ title, open = false, fill = false, className, children }: Props) {
  const [isOpen, setIsOpen] = useState(open);
  const id = useRef(`dropdown-${++nextId}`).current;

  return (
    <section className={cx(styles.section, { [styles.open]: isOpen, [styles.fill]: fill }, className)}>
      <h2 className={styles.heading}>
        <button
          type="button"
          id={`${id}-toggle`}
          className={styles.toggle}
          aria-expanded={isOpen}
          aria-controls={`${id}-panel`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className={styles.title}>{title}</span>
          <img className={styles.chevron} src={chevron} alt="" />
        </button>
      </h2>
      <div id={`${id}-panel`} role="region" aria-labelledby={`${id}-toggle`} className={styles.panel} hidden={!isOpen}>
        {children}
      </div>
    </section>
  );
}

export default Dropdown;
